import React, { useState, useRef, useEffect } from "react";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import ProductInfo from "./component-details/component-details-form";
import LastProcessorInfo from "./component-details/product-components";
import RawMaterialInfo, {
  ComponentRawMaterialInformation,
} from "./component-details/raw-material-info";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import {
  TcComponentInformation,
  TcComponentStandardInformation,
} from "../../../tc-models/tc-req-dto/input-tc-component-details.res_dto";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import { transactionCertificateService } from "../../../tc-service/transaction-certificate.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import {
  mapPayload,
  reverseMapPayload,
} from "../../payload/input-tc-components-payload";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import {
  DELETECONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import { isAdmin, isViewOnlyAdminMode } from "../../../../../shared/utils/admin-utils";
import {
  fetchProductComponentDetails,
  getProductDataByProductNo,
  mapComponentResponseToState,
  mapInputComponentData,
} from "./component-details-apis";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import _ from "lodash";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";

// interface InputTcComponentDetailProps {
//   onNextTab: () => Promise<void>;
// }

const initComponentInfo: TcComponentInformation = {
  inputTcComponentInformationOrder: "",
  inputTcProductNo: "",
  inputTcProductComponentNo: "",
  inputTcComponentDetail: "",
  inputTcComponentInfoTrimsExcluded: "",
  inputTcComponentInfoAssociatedTc: "",
  inputTcComponentInfoFiberLength: "",
  inputTcComponentInfoYarnCount: "",
  inputTcComponentInfoFabricWeightAndConstruct: "",
  inputTcComponentInfoFabricWeightOfFinishedProduct: "",
  // inputTcComponentNetShippingWeight: 0,
  // inputTcComponentSupplementaryWeight: '',
  inputTcComponentInfoAdditional: "",
};

const initStandardInfo: TcComponentStandardInformation[] = [];
const initRawMaterialInfo: ComponentRawMaterialInformation[] = [];

// interface InputTCComponentDetailsProps {
//   isNextDisabled: boolean;
// }

const InputTCComponentDetails = () => {
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    replaceTableDatas,
    updateField,
    removeTableRowbyIndex,
  } = useFormActions("input-tc-component-details");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [productId, setProductId] = useState<string | null>("");
  const {
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const [data, setData] = useState<any[]>([]);
  const { notify } = useNotification();
  const [stepData, setStepData] = useState({
    componentInfo: initComponentInfo,
    standardInfo: initStandardInfo,
    rawMaterialInfo: initRawMaterialInfo,
  });
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [isValueChanged, setIsValueChanged] = useState<boolean>(false);
  const navigate = useNavigate();
  const { isRestrictPopUpSave, setRestrictPopUpSave } =
    useTransactionCertificateStore();
  const isViewMode = isAdmin();
  const { TE_ID, formtype } = useParams<string>();
  const [tableData, setTableData] = useState([]);
  const { executeGet: executeProduct } = useApi();
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const componentInfoRef = useRef<any>(null);
  const [productData, setProductData] = useState([]);
  const formRefs = [componentInfoRef];
  const [apiData, setAPIData] = useState<[]>([]);
  const [inputTcComponentId, setInputTcComponentId] = useState<string>("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [pendingSave, setPendingSave] = useState<any>(null);
  const [shipmentId, setShipmentId] = useState<string | null>("");
  const [inputTcId, setInputTcId] = useState<string>("");
  const [pagination, setPagination] = useState<Pagination>({ pageIndex: 0, pageSize: 10 });
  const [rowCount, setRowCount] = useState<number>(0);
  const fetchComponentDetails = async () => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_INPUT_COMPONENT_DETAILS_LIST,
        { tcId: TE_ID, limit: pagination?.pageSize, offset: pagination?.pageIndex * pagination?.pageSize }
      );
      console.log(response);
      const result = response.data.response;
      setTableData(result);
      // setAPIData(result)
      setRowCount(response?.data?.no_of_records);
      setNextEnabled(true);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const shipmentFormData = async () => {
    try {
      const response = await executeProduct(
        TCAppConfig.GET_INPUT_TC_PRODUCTDETAILS_INFO,
        { tcId: TE_ID }
      );
      setProductData(response?.data.response);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const setZustandInitialState = (initialState?: any) => {
    const defaultState = {
      associatedShipmentNo: "",
      tcProductNo: "",
      tcProductCategoryCode: "",
      tcProductCategoryUserSpecificTerm: "",
      tcProductDetailCode: "",
      tcProductDetailUserSpecificTerm: "",
      tcProductProductionDate: "",
      tcProductNetShippingWeight: "",
      tcProductSupplementaryWeight: "",
      tcProductOrderNo: [""],
      tcProductShipmentNo: [""],
      tcProductArticleNo: "",
      tcProductNumberOfUnits: "",
      tcProductUnitsMetric: "",
      tcProductInfoAssociatedTc: "",
      tcIsLastProcessorTECertitfied: "Y",
      tcProductLastProcessorTeId: "",
      tcProductLastProcessorName: "",
      tcProductLastProcessorCountry: "",
      tcProductLastProcessorLicenseNo: "",
      tcProductInfoFiberLength: "",
      tcProductInfoYarnCount: "",
      tcProductInfoFabricWeightAndConstruct: "",
      tcProductInfoFabricWeightOfFinishedProduct: "",
      tcProductInfoTrimsExcluded: "",
      tcProductInfoAdditional: "",
      tcProductAdditives: [],
      tcProductAdditivesWeight: null,
      "raw-material-info": [
        {
          tcProductRawMaterialOrder: null,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: "",
        },
        {
          tcProductRawMaterialOrder: null,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: "",
        },
      ],
    };

    Object.entries(initialState ?? defaultState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };
  useEffect(() => {
    if (TE_ID) {
      fetchComponentDetails();
      shipmentFormData();
    }
    setZustandInitialState(null);
    setRestrictPopUpSave(false);
  }, [TE_ID, pagination?.pageIndex]);

  const toggleDrawer = () => {
    setActiveStep(0);
    setZustandInitialState();
    if (drawerOpen) {
      setStepData({
        componentInfo: initComponentInfo,
        standardInfo: initStandardInfo,
        rawMaterialInfo: initRawMaterialInfo,
      });
      setProductId(null);
      setShipmentId(null);
      setInputTcId("");
      setEditingIndex(-1);
      setPendingSave(null);
      setIsValueChanged(false);
      // const navigate = useNavigate();
    }
    setRestrictPopUpSave(false);
    setDrawerOpen((prev) => !prev);
  };

  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
    Utills.cl(`formRefs ${formRefs}`);
  };

  const steps = [
    {
      label: "Component Details",
      content: (
        <ProductInfo
          formRef={componentInfoRef}
          componentData={stepData.componentInfo}
          setComponentData={(data) => handleDataUpdate("componentInfo", data)}
        />
      ),
    },
    {
      label: "Product Component Standard Info",
      content: (
        <LastProcessorInfo
          componentStandardInfoData={stepData.standardInfo}
          setComponentStandardInfoData={(data) =>
            handleDataUpdate("standardInfo", data)
          }
        />
      ),
    },
    {
      label: "Raw Material Info",
      content: (
        <RawMaterialInfo
          rawMaterialData={stepData.rawMaterialInfo}
          setRawMaterialData={(data) =>
            handleDataUpdate("rawMaterialInfo", data)
          }
        />
      ),
    },
  ];

  const handleNext = async () => {
    if (formRefs[activeStep]?.current) {
      const errors = await formRefs[activeStep].current.validateForm();
      await formRefs[activeStep].current.submitForm();
      if (Object.keys(errors).length === 0) {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      }
    } else {
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
    }
  };
  useEffect(() => {
    const componentDetailsData = getCurrentTableData();
    Utills.cl(`componentDetailsData ${componentDetailsData}`);
    if (componentDetailsData) {
      setData(componentDetailsData);
    }
  }, []);
  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };

  const handleFinish = async () => {
    if (isViewOnlyAdminMode()) {
      navigate(`/tc/${formtype}/declaration-certification-body/${TE_ID}`);
      return;
    }
    
    if (activeStep === 2) {
      const newData = {
        ...stepData.componentInfo,
        standardInfo: stepData.standardInfo,
        rawMaterialInfo: stepData.rawMaterialInfo,
      };

      if (TE_ID) {
        const payload = mapInputComponentData(
          newData,
          TE_ID,
          inputTcComponentId
        );
        // If it's a new component or no changes to component number, save directly
        handleSave(payload);
      }
    }
  };

  const handleConfirmSave = async () => {
    try {
      // If we have a pending save payload, save it first
      if (pendingSave) {
        delete pendingSave.inputTcComponentId;
        await handleSave(pendingSave);
        setPendingSave(null);
      }

      // Then delete the existing record
      await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
        pageName: DELETECONFIG.inputTcComponent,
        tcId: TE_ID,
        inputTcId: inputTcId,
        shipmentId: shipmentId,
        productId: productId,
        inputTcComponentId: inputTcComponentId,
      });
      fetchComponentDetails();
      setDialogOpen(false);
      setInputTcComponentId("");
      setProductId("");
      setShipmentId("");
      setInputTcId("");

      notify("Successfully processed", "success");
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const handleCancelSave = () => {
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };

  const handleSave = async (payload: any) => {
    if (!TE_ID) return;

    setLoadingState(true);
    const shipmentMatches = getProductDataByProductNo(
      productData,
      payload.inputTcComponentInformation[0].inputTcProductNo
    );

    const shipmentData = shipmentMatches.length > 0 ? shipmentMatches[0] : null;
    const queryParams = new URLSearchParams({
      tcId: TE_ID,
      shipmentId: shipmentData ? shipmentData.shipmentId : "",
      productId: shipmentData ? shipmentData.productId : "",
      inputTcId: shipmentData ? shipmentData.inputTcId : "",
    }).toString();

    const oldInputTcIdParam = inputTcId ? inputTcId : shipmentData?.inputTcId??"";
    const oldProductIdParam = productId ? productId : shipmentData?.productId??"";
    const oldShipmentIdParam = shipmentId
      ? shipmentId
      : shipmentData?.shipmentId??"";

    const finalUrl = `${TCAppConfig.INPUT_TCCOMPONENTS_ENDPOINT}?${queryParams}&oldInputTcId=${oldInputTcIdParam}&oldProductId=${oldProductIdParam}&oldShipmentId=${oldShipmentIdParam}`;

    const result: any = await executePost(finalUrl, payload);
    if (result && result.status == 200) {
      notify("Data Saved Successfully", "success");
      setStepData({
        componentInfo: initComponentInfo,
        standardInfo: initStandardInfo,
        rawMaterialInfo: initRawMaterialInfo,
      });
      // Reset all IDs
      setInputTcComponentId("");
      setProductId("");
      setShipmentId("");
      setInputTcId("");
      setIsValueChanged(false);
      toggleDrawer();
      fetchComponentDetails();
    } else {
      setLoadingState(false);
      notify("Unable to Save", "error");
    }
  };

  const mapToTcComponentInformation = (data: any): TcComponentInformation => {
    return {
      inputTcComponentInformationOrder: "", // Assuming empty string, since it's not available in the provided data
      inputTcProductNo: data.inputTcProductNo,
      inputTcProductComponentNo: data.inputTcProductComponentNo,
      inputTcComponentDetail: data.inputTcComponentDetail,
      inputTcComponentInfoTrimsExcluded: data.inputTcComponentInfoTrimsExcluded,
      inputTcComponentInfoAssociatedTc: data.inputTcComponentInfoAssociatedTc,
      inputTcComponentInfoFiberLength: data.inputTcComponentInfoFiberLength,
      inputTcComponentInfoYarnCount: data.inputTcComponentInfoYarnCount,
      inputTcComponentInfoFabricWeightAndConstruct:
        data.inputTcComponentInfoFabricWeightAndConstruct,
      inputTcComponentInfoFabricWeightOfFinishedProduct:
        data.inputTcComponentInfoFabricWeightOfFinishedProduct,
      inputTcComponentNetShippingWeight: parseFloat(
        data.inputTcComponentNetShippingWeight
      ),
      inputTcComponentSupplementaryWeight: parseFloat(
        data.inputTcComponentSupplementaryWeight
      ),
      inputTcComponentInfoAdditional: data.inputTcComponentInfoAdditional,
    };
  };

  const mapToTcComponentStandardInformation = (
    productStandardInfo: any
  ): TcComponentStandardInformation[] => {
    Utills.cl(`productStandardInfo, ${JSON.stringify(productStandardInfo)}`);
    return productStandardInfo["product-component-standard-info"].map(
      (item: any) => ({
        inputTcComponentStandardInformationOrder:
          item.inputTcComponentStandardInformationOrder,
        inputTcComponentStandardLabelGrade:
          item.inputTcComponentStandardLabelGrade,
        inputTcComponentCertifiedWeight: parseFloat(
          item.inputTcComponentCertifiedWeight
        ),
        inputTcComponentCertifiedWeightUsed: parseFloat(
          item.inputTcComponentCertifiedWeightUsed
        ),
      })
    );
  };

  const mapToComponentRawMaterialInformation = (
    rawMaterialsInfo: any
  ): ComponentRawMaterialInformation[] => {
    return rawMaterialsInfo["raw-materials-info"].map((item: any) => ({
      inputComponentRawMaterialInformationOrder:
        item.inputComponentRawMaterialInformationOrder,
      inputTcComponentRawMaterialPercentage: parseFloat(
        item.inputTcComponentRawMaterialPercentage
      ),
      inputTcComponentRawMaterialCode: item.inputTcComponentRawMaterialCode,
    }));
  };
  const handleEdit = (row: any) => {
    const value = row?.original;
    setInputTcId(value.inputTcId);
    setProductId(value.productId);
    setInputTcComponentId(value.inputTcComponentId);
    setShipmentId(value.shipmentId);

    if (TE_ID) {
      fetchProductComponentDetails(
        executeGet,
        TE_ID,
        value.shipmentId,
        value.productId,
        value.inputTcId,
        value.inputTcComponentId
      )
        .then((data) => {
          const mappedStepData = mapComponentResponseToState(data.data);
          setStepData(mappedStepData);
          toggleDrawer();
        })
        .catch((err) => {
          notify(err.message, "error");
        });
    }

    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const onDelete = (row: any) => {
    const value = row?.original;
    setProductId(value.productId);
    setInputTcComponentId(value.inputTcComponentId);
    setShipmentId(value.shipmentId);
    setInputTcId(value.inputTcId);
    setDialogOpen(true);
    setPopUpTitle("Confirm Delete");
    setPopUpMessage(`Are you sure want to delete it`);
    setPopUpBtnName("Yes");
  };
  const onEditDelete = (row: any) => {
    const value = row?.original;
    setProductId(value.productId);
    setInputTcComponentId(value.inputTcComponentId);
    setShipmentId(value.shipmentId);
    setInputTcId(value.inputTcId);
    setDialogOpen(true);
    setPopUpTitle("Confirm Save");
    setPopUpMessage(
      "Editing a ComponentNo will remove all the Associated Records. Are you sure you want to edit it?"
    );
    setPopUpBtnName("Save");
  };
  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "inputTcProductComponentNo",
      header: "Product Component No.",
      minSize: 60,
      maxSize: 200,
    },
    {
      accessorKey: "inputTcComponentDetail",
      header: "Component Detail",
      minSize: 60,
      maxSize: 200,
    },
    {
      accessorKey: "inputTcComponentInfoTrimsExcluded",
      header: "Component Info Trims Excluded",
      minSize: 60,
      maxSize: 200,
    },
    {
      accessorKey: "inputTcComponentInfoAssociatedTc",
      header: "Component Info Associated TC",
      minSize: 60,
      maxSize: 200,
    },
    {
      accessorKey: "inputTcComponentInfoFiberLength",
      header: "Component Info Fiber Length",
      minSize: 60,
      maxSize: 200,
    },
    {
      accessorKey: "inputTcComponentInfoYarnCount",
      header: "Product Component Info Yarn Count",
      minSize: 60,
      maxSize: 200,
    },
    {
      accessorKey: "inputTcComponentInfoFabricWeightAndConstruct",
      header: "Component Info Fabric Weight And Construct (kg)",
      minSize: 60,
      maxSize: 250,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "inputTcComponentInfoFabricWeightOfFinishedProduct",
      header: "Component Info Fabric Weight of Finished Product (kg)",
      minSize: 60,
      maxSize: 250,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "inputTcComponentNetShippingWeight",
      header: "Component Net Shipping Weight (kg)",
      minSize: 60,
      maxSize: 200,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "inputTcComponentSupplementaryWeight",
      header: "Component Supplementary Weight (kg)",
      minSize: 60,
      maxSize: 200,
      Cell: Utills.usNumberFormat,
    },
  ];

  const renderDetailPanel = ({ row }: { row: any }) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 5,
        gap: 4,
        width: "50%",
      }}
    >
      {/* Standard Info */}
      <Box sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
          Product Component Standard Info
        </Typography>
        <CustomTable
          columns={[
            {
              accessorKey: "inputTcComponentStandardLabelGrade",
              header: "Standard Label Grade",
            },
            {
              accessorKey: "inputTcComponentCertifiedWeight",
              header: "Certified Weight (kg)",
              Cell: Utills.usNumberFormat,
            },
            {
              accessorKey: "inputTcComponentCertifiedWeightUsed",
              header: "Certified Weight Used (kg)",
              Cell: Utills.usNumberFormat,
            },
          ]}
          data={row.original["product-component-standard-info"]}
          enableTopToolbar={false}
          enableBottomToolbar={false}
        />
      </Box>
      <Divider />
      {/* Raw Material Info */}
      <Box sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
          Raw Material Info
        </Typography>
        <CustomTable
          columns={[
            {
              accessorKey: "inputTcComponentRawMaterialCode",
              header: "Raw Material Code",
            },
            {
              accessorKey: "inputTcComponentRawMaterialPercentage",
              header: "Raw Material Percentage",
            },
          ]}
          data={row.original["raw-materials-info"]}
          enableTopToolbar={false}
          enableBottomToolbar={false}
        />
      </Box>
    </Box>
  );

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as "default",
      disabled: activeStep === 0,
    }]:[],
    {
      label: isViewOnlyAdminMode() ? "Next" : (activeStep === steps.length - 1 ? "Save" : "Next"),
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained" as "contained",
      color: "primary" as "primary",
      disabled: (activeStep === 2 || activeStep === 1 )? isRestrictPopUpSave : false,
    },
  ];
  const handleNavigate = () => {
    navigate(`/tc/${formtype}/declaration-certification-body/${TE_ID}`);
  };

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end">
            {!hasSubmitTC && !isViewOnlyAdminMode() && (
              <StyledButton variant="contained" onClick={toggleDrawer}>
                Add Component
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              enableTopToolbar={false}
              enableRowActions={!hasSubmitTC}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>NO data</>
                )
              }
              renderRowActions={({ row }) => (
                <ActionsMenu
                  row={row}
                  onEdit={handleEdit}
                  onDelete={!isViewOnlyAdminMode() ? onDelete : undefined}
                />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Component Details"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              <NavLink to="/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              <InnerButton onClick={handleNavigate}>Next</InnerButton>
            </Box>
          ) : (
            <>
              {TE_ID && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: "0.5rem",
                  }}
                >
                  <NavLink to="/tc-dashboard">
                    <InnerButton>Home</InnerButton>
                  </NavLink>
                  {hasSubmitTC && (
                    <NavLink
                      to={`/tc/${formtype}/Input-tc-product-details/${TE_ID}`}
                    >
                      <InnerButton>Back</InnerButton>
                    </NavLink>
                  )}
                  <InnerButton onClick={handleNavigate}>Next</InnerButton>
                </Box>
              )}
            </>
          )}
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default InputTCComponentDetails;
